import { useDispatch } from 'react-redux';

import { toastError, toastSuccess } from '@components/Toast';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { fetchBrandProfileById } from '@store/actions/BrandProfileAction';

import ApiClient from '@lib/apiClient';

import { isValidFile, onUploadFile } from '@utils/Util';

import { BASE_URL, VALID_FILE_SIZE } from '@/constants/constant';

import CommonImage from '@/components/CommonImage';

const TermsAndCondition = ({ brandId, brandProfile }) => {
	const dispatch = useDispatch();

	const renderFiles = () => {
		return brandProfile?.brandDocResponseList?.map((item) => (
			<div className="single-pdf-file d-flex align-items-center mr-4 mb-2" key={item.docUrl}>
				<CommonImage src="/images/file.svg" alt="file image" className="add-to-favorite" width="24" />
				<span
					onClick={() => window.open(item.docUrl, '_blank')}
					className="regular-14 ml-1 cursor-pointer"
				>
					{item.name}
				</span>
				<div className="acton-img cursor-pointer ml-1" onClick={(e) => onRemoveDocument(e, item.id)}>
					<CommonImage src="/icons/delete_red.svg" alt="delete" className="" width="20" />
				</div>
			</div>
		));
	};

	const onChangeFile = async (postData) => {
		try {
			dispatch(openLoader());
			await ApiClient.POST(`${BASE_URL}/brand/${brandId}/document`, postData, '', true);
			dispatch(fetchBrandProfileById(brandId));
			toastSuccess('Uploaded successfully');
		} finally {
			dispatch(closeLoader());
		}
	};

	const onRemoveDocument = async (e, documentId) => {
		try {
			dispatch(openLoader());
			await ApiClient.DELETE(`${BASE_URL}/brand/${brandId}/document/${documentId}`, '', '', true);
			dispatch(fetchBrandProfileById(brandId));
			toastSuccess('Uploaded successfully');
		} catch {
			toastError('Error while deleting document');
		} finally {
			dispatch(closeLoader());
		}
	};

	const checkFileValidation = (e) => {
		let oldObj = { ...e.target.files };
		let arr = [];
		Object.keys(oldObj).map((item) => {
			arr.push(oldObj[item]);
		});
		const failedFiles = [];
		arr.forEach((file) => {
			const isValid = isValidFile(file, 'image', VALID_FILE_SIZE);
			if (!isValid) {
				failedFiles.push(file.name);
			}
		});
		if (failedFiles.length === 0) {
			onUploadFile(e, 'REFERENCE_IMAGE', onChangeFile, 'MULTIPLE');
		}
	};

	return (
		<div
			className="upload-img align-items-center justify-content-start"
			onClick={(e) => e.stopPropagation()}
		>
			<div className="file-uploader height-small upload-design-image mb-4 mb-sm-0">
				<div className="d-flex justify-content-start align-items-center">
					<label
						htmlFor="drag-upload"
						className="drag-upload d-flex justify-content-center align-items-center"
					>
						<CommonImage src="/icons/upload-blue.svg" alt="" className="" width="24" />
						<p className="ml-1">Upload</p>
					</label>
				</div>
				<input
					type="file"
					id="drag-upload"
					className="file-upload"
					name="image"
					multiple
					accept="image/*"
					onChange={checkFileValidation}
				/>
			</div>
			<div className="all-pdf-files d-flex flex-wrap justify-content-start align-items-center">
				{renderFiles()}
			</div>
		</div>
	);
};
export default TermsAndCondition;
